import "./DataAutomationTechnology.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Optimization from "./sections/Optimization";
import Automation from "./sections/Automation";
import Process from "./sections/Process";
import Benefits from "./sections/Benefits";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function DataAutomationTechnologyPage() {
  return <div>
      <Header />
      <Hero />
      <Optimization />
      <Automation />
      <Process />
      <Benefits />
      <Action />
      <Footer />
    </div>;
}